/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors, Title1, Title2 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";

interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface IModal {
  item: IModule | null;
  type: string | null;
  callback: (item: IModule, type: string, answer?: number) => void;
  handleModal: (state: boolean) => void;
}

function SentenceModal({ item, type, callback, handleModal }: IModal) {
  const [score, setScore] = useState<number>(0);

  const handleScore = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      setScore(Number(value));
    },
    [setScore]
  );

  const closeModal = useCallback(() => {
    handleModal(false);
  }, []);

  const handleSubmit = useCallback(() => {
    if (item && type) {
      closeModal();
      callback(item, type, score);
    }
  }, [score]);

  return (
    <Modals>
      <ModalBody>
        {item && type && (
          <>
            <Title1>{type}</Title1>
            <Contents>
              <Question>{item.question}</Question>

              <ContentsBox>
                <Audio src={item.answer_s3} controls />
              </ContentsBox>

              <Title2 align="left" marginTop={40}>
                Edit score
              </Title2>
              <Input onInput={handleScore} maxLength={2} />
            </Contents>
          </>
        )}
        {item && type && (
          <ButtonGroup>
            <ConfirmButton onClick={handleSubmit}>정답처리</ConfirmButton>
            <CancelButton onClick={closeModal}>취소</CancelButton>
          </ButtonGroup>
        )}
      </ModalBody>
    </Modals>
  );
}

const Modals = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${rgba(colors.Black, 0.5)};
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  width: 900px;
  padding: 30px;
  background-color: ${colors.White};
  border-radius: 15px;
`;

const Contents = styled.div``;

const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 20px;
  border: 1px solid ${colors.Gray30};
  border-radius: 10px;
  margin-top: 10px;
  font-size: 20px;
  text-align: right;

  &:focus {
    border: 1px solid ${colors.Gray30};
    outline: 0;
  }
`;

const ContentsBox = styled.div`
  flex-basis: calc(50% - 20px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Question = styled.div`
  padding: 20px;
  font-size: 36px;
  border: 1px solid ${colors.Black};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px auto;
`;

const Audio = styled("audio")`
  width: 100%;
`;

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 80px;
`;

const ConfirmButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 0;
  background-color: ${colors.Primary50};
  border-radius: 8px;
  color: ${colors.White};
  cursor: pointer;
`;

const CancelButton = styled.button`
  flex-basis: calc(50% - 10px);
  height: 50px;
  outline: 0;
  border: 1px solid ${colors.Black};
  background-color: ${colors.White};
  border-radius: 8px;
  color: ${colors.Black};
  cursor: pointer;
`;

export default SentenceModal;
